import { render, staticRenderFns } from "./branchallcountListForApp.vue?vue&type=template&id=35ac9234&scoped=true"
import script from "./branchallcountListForApp.vue?vue&type=script&lang=js"
export * from "./branchallcountListForApp.vue?vue&type=script&lang=js"
import style0 from "./branchallcountListForApp.vue?vue&type=style&index=0&id=35ac9234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac9234",
  null
  
)

export default component.exports